import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { __rest } from "tslib";
import React, { Component } from 'react';
import { DragDropContext as context } from 'react-dnd';
import backend from 'react-dnd-html5-backend';
import SortableItem from './SortableItem';
var Sortable = /*#__PURE__*/function (_Component) {
  function Sortable() {
    _classCallCheck(this, Sortable);
    return _callSuper(this, Sortable, arguments);
  }
  _inherits(Sortable, _Component);
  return _createClass(Sortable, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        children = _a.children,
        onItemsSort = _a.onItemsSort,
        onItemDrag = _a.onItemDrag,
        onItemHover = _a.onItemHover,
        tag = _a.tag,
        rest = __rest(_a, ["children", "onItemsSort", "onItemDrag", "onItemHover", "tag"]);
      var childrenProps = {
        onItemsSort: onItemsSort,
        onItemDrag: onItemDrag,
        onItemHover: onItemHover
      };
      return /*#__PURE__*/React.createElement(this.props.tag, Object.assign({}, rest), children.map(function (item, index) {
        return /*#__PURE__*/React.createElement(SortableItem, Object.assign({
          key: index,
          index: index
        }, childrenProps), item);
      }));
    }
  }]);
}(Component);
Sortable.defaultProps = {
  tag: 'div'
};
export default context(backend)(Sortable);